/* eslint-disable react/jsx-curly-brace-presence */
import { Card, Chip, Tooltip } from '@material-ui/core';
import { Button, DropDown } from '@synergy-marine-group/synergy-ui';
import React, { useEffect, useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import Modal from 'react-responsive-modal';
import polygon from '../../images/icons/polygon.svg';
import datePicker from '../../images/icons/datePicker.svg';
import iconTrash from '../../images/icons/ico-trash.svg';
import iconTrashYellow from '../../images/icons/ico-trash-yellow.svg';
import warningIcon from '../../images/icons/triangleExclamation.svg';
import tickWhiteIcon from '../../images/icons/tick-white.svg';
import Header from '../common/Header';
import PrintIcon from '../../images/icons/printer.svg';
import Comment from './Comment';
import Loader from '../common/Loading';
import { getPO, getPOQuery } from './queries/getPO';
import downloadPO from './queries/downloadPO';
import Footer from '../common/Footer';
import deleteLineItemLevel from './queries/deleteLineItemLevel';
import showAlert from '../../utils/alert';
import getExpenseCategoryJSONlist from './queries/getExpenseCategoryJsonList';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import ConfirmShortClose from '../Modal/ConfirmShortClose';
import ConfirmApprovel from '../Modal/ConfirmApprovel';
import RequestShortClose from '../Modal/RequestShortClose';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import PPETable from './PpeTable';
import { getVendorPO, getVendorPOQuery } from './queries/getVendorPo';
import { getShortCloseApprovalQuery } from './queries/getShortCloseApproval';
import requestShortCloseLineItem from './queries/requestShortCloseLineItem';
import CompassWithPopup from '../Modal/CompassWithPopup';
import ShortCloseApprovalSection from './ShortCloseApprovalSection';
import ApprovalFlowLog from './ApprovalFlowLog';
import PoAttachments from './PoAttachments';
import AdvanceRequestDetailView from './AdvanceRequestDetailView';
import getAdvanceRequestPurchaseOrder from './queries/getAdvanceRequestPurchaseOrder';
import getPaymentTerms from './queries/getPaymentTerms';
import postPoRequestApproval from './queries/postPoRequestApproval';
import getLevel2ApproverList from './queries/getLevel2ApproverList';
import updateLevel2Approver from './queries/updateLevel2Approver';

const formatVesselWithSapCompanyCode = (vesselName, sapCompanyCode) => {
  const name = (vesselName && String(vesselName).trim()) || '';
  const sap = (sapCompanyCode != null && String(sapCompanyCode).trim() !== '')
    ? String(sapCompanyCode).trim()
    : '';
  if (name && sap) return `${name} (${sap})`;
  if (name) return name;
  return '-';
};

const PODetailPage = () => {
  const [modalData, setModalData] = useState(null);
  const [modal, setModal] = useState(false);
  const history = useHistory();
  const { poId, isVendor } = useParams();
  const [openHeader, setopenHeader] = useState(true);
  const [openCrew, setopenCrew] = useState(true);
  const [openDate, setopenDate] = useState(true);
  const [show, setShow] = useState([]);
  const [finalFetch, setFinalFetch] = useState(null);
  const policies = returnPolicies();
  const [isCrewPage, setisCrewPage] = useState();

  const columns = [];
  const [shortCloseReason, setShortCloseReason] = useState('');
  const [showApprovePopup, setShowApprovePopup] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [selectedLineItem, setSelectedLineItem] = useState(null);
  const [showAll, setShowAll] = useState([]);
  const { data, isError: isPoError, isLoading: poLoading } = isVendor === 'true'
  ? getVendorPO(poId) : getPO(poId);
  const [approvalConfig, setApprovalConfig] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  const {
    mutate: download,
    isSuccess: isdownloadSuccess,
    isLoading: downloadLoading,
    isError: isdownloadError,
    reset
  } = downloadPO(poId, data?.data?.poNumber);
  const { mutate: deleteLineItem, isLoading: deleteLineItemLoading } = deleteLineItemLevel();
  const { mutate: initiateShortClose, isLoading: isSCLoading } = requestShortCloseLineItem();
  const { data: expenseCategory } = getExpenseCategoryJSONlist();
  const expenseCategoryList = formatDropdownOptions(expenseCategory?.data, 'categoryName', 'expenseCategoryID');
  const {
    id,
    vendorId,
    vendorsName,
    sapVendorCode,
    sapCompanyCode,
    poNumber,
    totalInvoiceAmount,
    totalUSDInvoiceAmount,
    totalUSDAmount,
    poStatus,
    dueDate,
    invoiceCurrency,
    description,
    expenseCategoryName,
    expenseCategoryId,
    purchaseOrderCrew,
    companyName,
    crewTotalAmount,
    currency,
    dateOfService,
    createdAt,
    budgetCategory,
    isActive,
    portName,
    serviceCompletionDate,
    isEnableAgencyPoApproval,
    isEnableAgencyPoReject,
    isEnableUpdateLevel2Approver,
    isAgencyPoEditable,
    level2Approver: level2ApproverFromPo,
    sapPoNumber,
    sapPoNumberPosition
  } = data?.data || {};
  const poData = data?.data || {};
  const normalizedSapPoNumberPosition = (sapPoNumberPosition || '').toLowerCase().replace(/[^a-z]/g, '');
  const showHeaderSapPoNumber = normalizedSapPoNumberPosition === 'header';
  const showLineItemSapPoNumber = normalizedSapPoNumberPosition === 'lineitem';
  const isShortclosePossible = poData.isAgencyPoShortclosePossible === true
    || poData.isAgencyPoShortclosePossibe === true;
  const NULL_LEVEL2_GUID = '00000000-0000-0000-0000-000000000000';
  const level2ApproverId = (() => {
    const raw = level2ApproverFromPo;
    if (raw == null) return '';
    if (typeof raw === 'string') return raw;
    if (typeof raw === 'number') return String(raw);
    if (typeof raw === 'object') return raw?.id ?? raw?.value ?? '';
    return '';
  })();
  const level2ApproverIdNormalized = (level2ApproverId || '').toLowerCase() === NULL_LEVEL2_GUID.toLowerCase()
    ? ''
    : level2ApproverId;
  const isAgencyPage = isCrewPage === 'agency';
  const isCrewPageOnly = isCrewPage === 'crew';
  const showAgencyApprovalButtons = isAgencyPage
    && (isEnableAgencyPoApproval === true || isEnableAgencyPoReject === true);
  const canUpdateLevel2Approver = isAgencyPage && (
    isEnableUpdateLevel2Approver === true
    || (poStatus === 'Approved (Level1)' && !showAgencyApprovalButtons)
  );
  const canSelectLevel2ForApproval = showAgencyApprovalButtons
    && poStatus !== 'Amendment Initiated';
  const isLevel2DropdownEditable = canUpdateLevel2Approver || canSelectLevel2ForApproval;
  const showLevel2ApproverSection = isAgencyPage;
  const { mutate: postApproval, isLoading: isApprovalLoading } = postPoRequestApproval();
  const {
    mutate: updateLevel2ApproverMutation,
    isLoading: isUpdateLevel2Loading
  } = updateLevel2Approver();
  const [agencyApprovalModal, setAgencyApprovalModal] = useState({ open: false, action: null });
  const [agencyApprovalComment, setAgencyApprovalComment] = useState('');
  const [selectedLevel2ApproverId, setSelectedLevel2ApproverId] = useState('');
  const [level2ApproverOpen, setLevel2ApproverOpen] = useState(true);
  const level2ApproverParams = useMemo(
    () => ({
      companyId: data?.data?.companyId ?? data?.data?.company?.id,
      expenseCategoryId: data?.data?.expenseCategoryId
    }),
    [data?.data?.companyId, data?.data?.company?.id, data?.data?.expenseCategoryId]
  );
  const { data: level2ApproverResponse } = getLevel2ApproverList(level2ApproverParams, {
    enabled: showLevel2ApproverSection
      && (level2ApproverParams.companyId != null && level2ApproverParams.companyId !== '')
      && (level2ApproverParams.expenseCategoryId != null && level2ApproverParams.expenseCategoryId !== '')
  });
  const level2ApproverList = (() => {
    const raw = level2ApproverResponse?.data;
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw?.data)) return raw.data;
    if (raw && Array.isArray(raw?.result)) return raw.result;
    return [];
  })();
  const level2ApproverOptions = useMemo(() => {
    const toGuid = (v) => {
      if (v == null) return '';
      if (typeof v === 'string') return v;
      if (typeof v === 'number') return String(v);
      if (typeof v === 'object') return v?.id ?? v?.value ?? '';
      return '';
    };
    const list = level2ApproverList || [];
    const options = list.map((item) => {
      const optionId = toGuid(item?.id);
      return {
        label: item.name && item.email ? `${item.name} (${item.email})` : (item.name || item.email || optionId),
        value: optionId
      };
    });
    const fromListIds = new Set(options.map((o) => o.value));
    const nullGuid = '00000000-0000-0000-0000-000000000000';
    if (level2ApproverFromPo) {
      const poApproverId = toGuid(level2ApproverFromPo?.id ?? level2ApproverFromPo);
      const isNullGuid = (poApproverId || '').toLowerCase() === nullGuid.toLowerCase();
      if (poApproverId && !isNullGuid && !fromListIds.has(poApproverId)) {
        const name = level2ApproverFromPo?.name ?? '';
        const email = level2ApproverFromPo?.email ?? '';
        const label = name && email ? `${name} (${email})` : (name || email || poApproverId);
        options.push({ label, value: poApproverId });
      }
    }
    return [{ label: 'Select', value: '' }, ...options];
  }, [level2ApproverList, level2ApproverFromPo]);
  useEffect(() => {
    if (level2ApproverIdNormalized != null && level2ApproverIdNormalized !== '') {
      setSelectedLevel2ApproverId(level2ApproverIdNormalized);
    }
  }, [level2ApproverIdNormalized]);
  const { data: arqDataResponse } = getAdvanceRequestPurchaseOrder(id ?? poId, {
    enabled: isAgencyPage && !!(id ?? poId)
  });
  const advancePurchaseOrderFromApi = (() => {
    const raw = arqDataResponse?.data;
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.data)) return raw.data;
    if (raw && Array.isArray(raw.result)) return raw.result;
    return [];
  })();
  const { data: paymentTermsData } = getPaymentTerms();
  const paymentTermsOptions = useMemo(() => {
    const list = paymentTermsData?.data ?? paymentTermsData?.data?.data ?? paymentTermsData ?? [];
    const arr = Array.isArray(list) ? list : [];
    return arr.map((t) => ({
      value: t.id ?? t.value,
      label: t.description ?? t.paymentTerm ?? t.displayName ?? t.name ?? String(t.id ?? '')
    }));
  }, [paymentTermsData]);
  useEffect(() => {
  setisCrewPage(JSON.parse(localStorage.getItem('isPageHandler')));

            if (isVendor === 'true') {
              getVendorPOQuery(poId)
              .then((res) => {
             setFinalFetch(res?.data);
            });
          } else {
              getPOQuery(poId)
              .then((res) => {
             setFinalFetch(res?.data);
            });
            }
}, [poId]);
  useEffect(() => {
    let modified = false;
    if (poStatus === 'Draft' && finalFetch !== null) {
      finalFetch?.purchaseOrderCrew?.forEach((item) => {
        if (item?.ppeIsModified === true) {
          modified = true;
        }
      });
    }
    if (modified) {
      showAlert('PO details are updated as per the latest Master data change. Kindly review before sending the PO', 'warning');
    }
  }, [finalFetch]);

if (currency === 'USD') {
  columns.push('Item', 'Size', 'Quantity', 'Unit Price(USD)', 'Total Price(USD)');
} else {
  columns.push('Item', 'Size', 'Quantity', 'Unit Price(INR)', 'Total Price(INR)');
}
  const category = expenseCategoryList?.find((
    { expenseCategoryID }
    ) => expenseCategoryID === expenseCategoryId);

  const CalculateNoOfDays = (checkIn, checkOut) => {
    let days;
    if (checkIn) {
      if (checkOut) {
        const startDate = moment(checkIn);
        const endDate = moment(checkOut);
        days = endDate.diff(startDate, 'days');
      }
    }
    return days;
  };

  useEffect(() => {
      if ((isVendor === 'false' || !isVendor) && policies?.poPolicies?.canAccess === false) {
        history.push('/unauthorized');
      }
    }, [policies]);

  const loginUserEmail = useMemo(() => {
    try {
      const key = `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`;
      const user = localStorage.getItem(key);
      return JSON.parse(user)?.profile?.email || '';
    } catch {
      showAlert('Unable to obtain authentication information.');
      return '';
    }
  }, []);

  if (poLoading || downloadLoading) {
    return <Loader message="Loading" />;
  }

  if (isPoError) {
    showAlert('Something went wrong', 'error');
  }

  if (isdownloadSuccess) {
    showAlert('Purchase Order Downloaded Successfully', 'success');
    reset();
  }
  if (isdownloadError) {
    showAlert('Something went wrong', 'error');
    reset();
  }
  if (deleteLineItemLoading) {
    return <Loader message="Deleting Line Item" />;
  }
  const checkCategoryValues = (categoryValue) => {
    if (categoryValue?.find((item) => item?.value)) {
      return true;
    }
    return false;
  };
 const handleEdit = () => {
    if (isAgencyPage) {
      history.push(`/edit-agency-po/${poId}`);
    } else {
      history.push(`/edit-po/${poId}`);
    }
  };

  const handleApprove = (item) => {
    setSelectedLineItem(item);
    setShowApprovePopup(true);
  };

  const handleReject = (item) => {
    setSelectedLineItem(item);
    setShowRejectPopup(true);
  };

  const openDeleteModal = async (lineItemId, purchaseOrderId) => {
    setisLoading(true);
    try {
      const config = await getShortCloseApprovalQuery(vendorId, purchaseOrderId, lineItemId);
      setApprovalConfig(config);
      setModalData(lineItemId);
      setModal(true);
    } catch (error) {
      showAlert('Oops! Something went wrong.', 'error');
    } finally {
      setisLoading(false);
    }
  };

  const handleDownload = () => {
    download();
  };

  const handleCancel = () => {
    history.push('/');
  };

  const APPROVAL_ACTION = { Rejected: 0, Approved: 1, SentBack: 2 };
  const openAgencyApprovalModal = (action) => setAgencyApprovalModal({ open: true, action });
  const closeAgencyApprovalModal = () => {
    setAgencyApprovalModal({ open: false, action: null });
    setAgencyApprovalComment('');
  };
  const isLevel2SelectionValid = (level2Id) => {
    const trimmed = (level2Id || '').trim();
    return trimmed && trimmed.toLowerCase() !== NULL_LEVEL2_GUID.toLowerCase();
  };

  const handleUpdateLevel2Approver = () => {
    if (!isLevel2SelectionValid(selectedLevel2ApproverId)) {
      showAlert('Please select Level 2 Approver before updating.', 'error');
      return;
    }
    updateLevel2ApproverMutation(
      {
        purchaseOrderId: id ?? poId,
        level2Approver: selectedLevel2ApproverId
      },
      {
        onSuccess: () => {
          showAlert('Level 2 Approver updated successfully.', 'success');
        },
        onError: () => {
          showAlert('Something went wrong.', 'error');
        }
      }
    );
  };

  const isUpdateLevel2ButtonDisabled = isUpdateLevel2Loading
    || !isLevel2SelectionValid(selectedLevel2ApproverId);

  const submitAgencyApproval = () => {
    const actionMap = {
      Approve: APPROVAL_ACTION.Approved,
      Reject: APPROVAL_ACTION.Rejected,
      SendBack: APPROVAL_ACTION.SentBack
    };
    const actionValue = actionMap[agencyApprovalModal.action];
    if (actionValue === undefined) return;
    const level2IdTrimmed = (selectedLevel2ApproverId || '').trim();
    const level2IsEmpty = !level2IdTrimmed
      || level2IdTrimmed.toLowerCase() === NULL_LEVEL2_GUID.toLowerCase();
    if (agencyApprovalModal.action === 'Approve' && level2IsEmpty) {
      showAlert('Please select Level 2 Approver before approving.', 'error');
      return;
    }
    const level2ForPayload = level2IsEmpty
      ? undefined
      : (selectedLevel2ApproverId || undefined);
    postApproval(
      {
        purchaseOrderId: id ?? poId,
        approvalAction: actionValue,
        approverComments: agencyApprovalComment || '',
        level2Approver: level2ForPayload
      },
      {
        onSuccess: () => {
          const msg = agencyApprovalModal.action === 'Approve' ? 'Approved'
            : agencyApprovalModal.action === 'Reject' ? 'Rejected' : 'Sent Back';
          showAlert(`PO ${msg} successfully.`, 'success');
          closeAgencyApprovalModal();
        },
        onError: () => {
          showAlert('Something went wrong.', 'error');
        }
      }
    );
  };

  const handleShortClose = (formValues) => {
    if (!modalData) return;

    initiateShortClose(
      { formValues, lineItemId: modalData },
      {
        onSuccess: () => {
          setModal(false);
          showAlert('Purchase Order Short Close Request Initiated.', 'success');
        }
      }
    );
  };

  const handleDelete = () => {
    deleteLineItem({ id: modalData, reason: shortCloseReason });
    setModal(false);
    setModalData(null);
    setShortCloseReason('');
  };

  const handleDate = (date) => {
    if (date) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '';
  };
  return (
    <div className="md:w-full mb-20">
      <Header parentPageLink="/" currentPage="Purchase Order" parentPage="Purchase Order List" headerName="Purchase Orders" />
      <Card className="h-full overflow-visible-custom mx-12 mb-6" variant="Header">
        <div className="px-8 py-8">
          <div className="flex flex-col">
            <div className="flex flex-row justify-between">
              <div className="w-full md:w-1/2 capitalize text-amber-500 font-bold text-base flex items-center">
                {poNumber}
                <span className="pl-2">
                  {poStatus && (
                    <Chip style={{ backgroundColor: dueDate >= 180 ? '#f68681' : '#f8e3b4', borderRadius: 0 }} size="small" label={poStatus} />
                  )}
                </span>
              </div>
              <div className="w-auto justify-items-end flex flex-row justify-between">
                <Button
                type="button"
                className="disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleDownload}
                disabled={poStatus?.toLowerCase() === 'draft'}
                style={poStatus?.toLowerCase() === 'draft' ? { borderColor: '#9CA3AF', color: '#6B7280' } : {}}
                rounded
                hidden={policies?.poPolicies?.canPdfDownload === false}
                size="medium"
                variant="outlined"
                >
                  <div className="flex">
                    <img src={PrintIcon} alt="PrintIcon" />
                    <div className="ml-2">Download</div>
                  </div>
                </Button>
              </div>
            </div>
            <div className="w-full md:w-1/2 text-sm" style={{ color: dueDate >= 180 ? '#f68681' : '#4a4a4a' }}>
              {createdAt && (
                <div className=" pr-4">
                  {(poStatus === 'Submitted' || poStatus === 'Amended' || poStatus === 'Partially Closed') && dueDate >= 0 ? (
                    <span>
                      {dueDate}
{' '}
{dueDate === 1 ? 'Day ago' : 'Days ago'}
                    </span>
                  ) : null}
                  {' ('}
                  {moment(createdAt).format('DD-MM-YYYY')}
                  {')'}
                </div>
              )}
            </div>
          </div>
          {finalFetch?.isSyncFailure === true && (
          <div className="col-span-3 flex flex-row mt-2 ">
            <img className="action-icon w-6 mr-2" src={warningIcon} alt="warning" title="warning" />
            <div className="text-sm text-red-500 ">
              <span>Update rejected by </span>
            {finalFetch?.externalTrainingSource}
            <span> application. Please contact administrators or support team</span>
            </div>
          </div>
          )}
          <div
            onClick={() => {
              return setopenHeader(!openHeader);
            }}
            className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
          >
            <span className="text-base font-montserrat text-white-light capitalize font-bold">Header level Details</span>
            <img src={polygon} alt="polygon" className={`${!openHeader ? 'transform -rotate-90' : ''} w-6`} />
          </div>
          {/* create a two column section with flex */}
          {openHeader && (
            <div className="text-gray-500 p-4 text-sm font-muli">
              <div className="header-grid">
                <div className="text-gray-300">
                  <span className="text-sm">Category:</span>
                  <span className="font-bold text-sm">{expenseCategoryName}</span>
                </div>
                <div className=" text-gray-300">
                  <span className="text-sm">Vendor: </span>
                  <span className="font-bold text-sm">
                    {formatVesselWithSapCompanyCode(vendorsName, sapVendorCode)}
                  </span>
                </div>
                <div className=" text-gray-300">
                  <span className="text-sm">PO Amount: </span>
                  <span className="font-bold text-sm break-normal">
                  {currency}
                  {' '}
                  {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(crewTotalAmount)}
                  {currency !== 'USD' && (
                    <>
                    {' (USD '}
                    {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(totalUSDAmount) || '-'}
                    {')'}
                    </>
                  )}
                  </span>
                </div>
                {showHeaderSapPoNumber && (
                  <div className="text-gray-300">
                    <span className="text-sm">SAP PO Number: </span>
                    <span className="font-bold text-sm">{sapPoNumber || '-'}</span>
                  </div>
                )}
                <div className="text-gray-300">
                  <span className="text-sm">Budget Category: </span>
                  <span className="font-bold text-sm">{budgetCategory || '-'}</span>
                </div>
                {/* Company should be changed to single value, instead of array */}
                <div className="text-gray-300">
                  <span className="text-sm">Company:</span>
                  <span className="font font-bold text-sm">
                    {formatVesselWithSapCompanyCode(companyName, sapCompanyCode)}
                  </span>
                </div>

                <div className="text-gray-300">
                  <span className="text-sm">Invoice Amount: </span>
                  {totalInvoiceAmount
                  ? (
                  <span className="font-bold text-sm break-normal">
                  {invoiceCurrency}
                  {' '}
                  {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(totalInvoiceAmount)}
                  {invoiceCurrency.trim() !== 'USD' && (
                    <>
                    {' (USD '}
                    {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(totalUSDInvoiceAmount) || '-'}
                    {')'}
                    </>
                    )}
                  </span>
                  ) : '-'}
                </div>
                {isAgencyPage && (
                  <>
                    <div className="text-gray-300">
                      <span className="text-sm">Port Name: </span>
                      <span className="font-bold text-sm">{portName || data?.data?.port?.portName || data?.data?.port?.name || '-'}</span>
                    </div>
                    <div className="text-gray-300">
                      <span className="text-sm">Service Completion Date: </span>
                      <span className="font-bold text-sm">
                        {serviceCompletionDate ? moment(serviceCompletionDate).format('DD-MM-YYYY') : '-'}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {/* crew details showing section */}
          <div
            onClick={() => {
              return setopenCrew(!openCrew);
            }}
            className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
          >
            <span className="text-base font-montserrat text-white-light capitalize font-bold">Line item level Details</span>
            <img src={polygon} alt="polygon" className={`${!openCrew ? 'transform -rotate-90 ' : ''} w-6`} />
          </div>
          {openCrew && (
            <>
              {purchaseOrderCrew?.map((item, key) => (
                <>
                  <div
                    style={{ backgroundColor: item?.isShortClosed ? '#F1F1F1' : '#F0F3FB' }}
                    className=" text-gray-500 border-b-2 p-2 border-primary-100 items-center  mt-4 rounded-t-md flex flex-row justify-between"
                  >
                    {isCrewPageOnly && (
                    <div className="w-1/4 uppercase font-bold">
                      {item.firstName}
                     {' '}
                     {item.lastName}
                    </div>
                    )}
                     {!isCrewPageOnly && (
                    <div className="w-1/4 uppercase font-bold">
                      {formatVesselWithSapCompanyCode(
                        item.plannedVesselName,
                        item.plannedVesselSapCompanyCode
                      )}
                    </div>
                    )}
                      {isCrewPageOnly && (
                    <div className="w-1/5 uppercase">
                      {item.crewCode && (
                      <div className="break-all">
                    <div className="uppercase">
                        #
                        {' '}
                        {item.crewCode}
                    </div>
                      </div>
                      )}
                    </div>
                     )}
                    {!isCrewPageOnly && item.plannedVesselCode && (
                    <div className="w-1/4 uppercase">
                       #
                       {' '}
                      {item.plannedVesselCode}
                    </div>
                    )}
                    {!isCrewPageOnly && item.plannedVesselImo && (
                    <div className="w-1/4 uppercase">
                        imo-
                        {item.plannedVesselImo}
                    </div>
                   )}
                    {(isCrewPageOnly) && (
                    <div className="w-1/12 uppercase">
                        {item.gender }
                    </div>
                  )}
                   {isCrewPageOnly && (
                    <div className="w-1/5 uppercase">
                      <div className="break-all">
                        <div className="uppercase">
                          {item.sapBPNumber || '-'}
                        </div>
                      </div>
                    </div>
                    )}
                    {isCrewPageOnly && (
                    <div className="w-1/4 uppercase">{item.rankName}</div>

                    )}
                      {isCrewPageOnly && (
                    <div className="w-1/4 uppercase">{item?.positionName || '-'}</div>
                    )}
                    <div className="w-1/5 capitalize text-right">
                      {(item?.invoiceStatus || item?.isShortClosed || item?.serviceStatus === 'Apportioned') && (
                        <Chip
                          label={item?.isShortClosed ? 'Short Closed' : (item?.invoiceStatus || item?.serviceStatus)}
                          variant="outlined"
                          color={item?.isShortClosed ? '' : 'primary'}
                          size="small"
                          className="bg-secondary-900 text-black font-bold"
                        />
                      )}
                    </div>
                    <div className="w-1/8 p-2 text-right flex gap-5">
                      {item?.shortCloseInitiatedDetails
                        && !(isAgencyPage && isAgencyPoEditable === false) && (
                        <CompassWithPopup
                          shortCloseInitiatedDetails={item.shortCloseInitiatedDetails}
                          isVendor={isVendor === 'true'}
                          loggedInUserEmail={loginUserEmail}
                        />
                      )}
                      <div
                        type="button"
                        className={
                          (isAgencyPage && isAgencyPoEditable === false)
                          || (isAgencyPage && !isShortclosePossible)
                            ? 'podetails-action-icon opacity-50 cursor-not-allowed'
                            : 'podetails-action-icon cursor-pointer'
                        }
                        hidden={
                          item?.isShortClosed
                          || item?.serviceStatus
                          || policies?.poPolicies?.canEdit === false
                          || (isAgencyPage === true && !policies?.agencyPoPolicies?.canEdit)
                          || item?.invoiceStatus?.toLowerCase().includes('payment')
                          || item?.invoiceStatus?.toLowerCase().includes('voucher')
                          || item?.invoiceStatus?.toLowerCase().includes('transferred')
                          || item?.isUserApprover
                          || isVendor === 'true'
                        }
                        onClick={() => {
                          const shortCloseDisabled = (isAgencyPage && isAgencyPoEditable === false)
                            || (isAgencyPage && !isShortclosePossible);
                          if (!shortCloseDisabled) {
                            openDeleteModal(item?.id, item?.purchaseOrderId);
                          }
                        }}
                        title={
                          isAgencyPage && isAgencyPoEditable === false
                            ? 'Short close is not available for this PO'
                            : isAgencyPage && !isShortclosePossible
                              ? 'Short close is not possible for this PO'
                              : 'Short Close'
                        }
                      >
                        <img className="action-icon w-6" src={item?.shortCloseInitiatedDetails?.isShortCloseInitiated ? iconTrashYellow : iconTrash} alt="short-close" />
                      </div>
                    </div>
                  </div>
                  <div style={{ gridTemplateColumns: '65% 35%' }} className="grid grid-cols-2 justify-between bg-secondary-50 break-words">
                    <div
                      style={{ backgroundColor: item?.isShortClosed ? '#F1F1F1' : '#F0F3FB' }}
                      className=" text-gray-300 grid grid-cols-3 gap-6 p-4 rounded-md content-start"
                    >
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Expense Line Item</div>
                        <div className="font-muli font-bold">{item.expenseLineItem || '-'}</div>
                      </div>
                      {isCrewPageOnly && (
                      <div className="flex flex-col gap-1">
                       <div className="font-muli w-80">Planned Vessel</div>
                        <div className="font-muli w-auto h-auto font-bold">
                          {formatVesselWithSapCompanyCode(
                            item.plannedVesselName,
                            item.plannedVesselSapCompanyCode
                          )}
                        </div>
                      </div>
                      )}
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Account Code</div>
                        <div className="font-muli font-bold">{item.accountCode || '-'}</div>
                      </div>
                      {showLineItemSapPoNumber && (
                        <div className="flex flex-col gap-1">
                          <div className="font-muli">SAP PO Number</div>
                          <div className="font-muli font-bold">{item.sapPoNumber || '-'}</div>
                        </div>
                      )}
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">SAP Sequence Number</div>
                        <div className="font-muli font-bold">
                          {(item?.sapSequenceNumber ?? '') !== '' ? item.sapSequenceNumber : '-'}
                        </div>
                      </div>
                      {isCrewPageOnly && (
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">DOB & Age</div>
                        {item?.dateOfBirth ? (
                          <div className="font-muli font-bold">
                            {moment(item?.dateOfBirth).format('DD-MM-yyyy')}
{' '}
(
{item?.age}
)
                          </div>
                        ) : (
                          <div className="font-muli font-bold">-</div>
                        )}
                      </div>
                    )}
                      {isCrewPageOnly && (
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Address</div>
                        <div className="font-muli font-bold inline-block">
                          {item?.address
                          || item?.city || item?.state || item?.pinCode || item?.country ? (
                            <>
                              {item.address && <div className="text-sm">{item.address}</div>}
                              {item.city && <div className="text-sm">{item.city}</div>}
                              {item.state && item.state}
{' '}
{item.pinCode && item.pinCode}
                              {item.country && <div className="text-sm">{item.country}</div>}
                            </>
                          ) : (
                            <div className="font-muli font-bold">-</div>
                          )}
                        </div>
                      </div>
                    )}
                     {isCrewPageOnly && (
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Joined Vessel</div>
                        <div className="font-muli font-bold inline-block">
                          {formatVesselWithSapCompanyCode(
                            item?.joinedVesselName,
                            item?.joinedVesselSapCompanyCode
                          )}
                        </div>
                      </div>
                     )}
                      {item?.airfareValue && (
                        <div className="flex flex-col gap-1">
                          <div className="font-muli">Airfare Status</div>
                          <div className="font-muli font-bold">{item.airfareValue || '-'}</div>
                        </div>
                      )}
                       {isCrewPageOnly && (
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Invoiced Vessel</div>
                        <div className="font-muli font-bold inline-block">
                          {formatVesselWithSapCompanyCode(
                            item?.invoicedVesselName,
                            item?.invoicedVesselSapCompanyCode
                          )}
                        </div>
                      </div>
                     )}
                      <div />
                      {item?.reason?.reason && (
                        <div className="col-span-3 ">
                          <span className="font-muli text-sm"> Reason for Short Close: </span>
                          {showAll.indexOf(key) > -1 ? (
                              <span
                              className="italic text-sm"
                              style={{ color: '#4a4a4a' }}
                              >
                              {item?.reason?.reason}
                              {item?.reason?.reason?.length > 50 && (
                                <span
                                  className="cursor-pointer text-secondary-900 text-sm italic"
                                  onClick={() => {
                                    const temp = [...showAll];
                                    temp.splice(temp.indexOf(key), 1);
                                    setShowAll(temp);
                                  }}
                                >
                                  {' '}
                                  Read less
                                </span>
                              )}
                              </span>
                          ) : (
                            <span
                            className="italic text-sm"
                            style={{ color: '#4a4a4a' }}
                            >
                              {item?.reason?.reason?.slice(0, 50)}
                              {item?.reason?.reason?.length > 50 && (
                                <span
                                  className="cursor-pointer text-secondary-900 text-sm italic"
                                  onClick={() => {
                                    const temp = [...showAll];
                                    temp.push(key);
                                    setShowAll(temp);
                                  }}
                                >
                                  ...Read more
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                      )}

                    </div>
                    <div
                      style={{ backgroundColor: item?.isShortClosed ? '#F1F1F1' : '#F0F3FB' }}
                      className="border-l-2 border-gray-100 text-gray-300 grid grid-cols-2 gap-6 p-4 break-words content-start"
                    >
                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Amount</div>
                       {item?.amount ? (
                          <div className="font-muli font-bold text-secondary-900 break-normal">
                            {currency}
                            {' '}
                            {item?.airfareValue === 'Cancelled' ? '-' : null}
                            {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item?.amount)}
                            {currency?.trim() !== 'USD' && (
                            <>
                              {' (USD '}
                            {item?.airfareValue === 'Cancelled' ? '-' : null}
                              {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item?.usdAmount) || '-'}
                              {')'}
                            </>
                            )}
                          </div>
                        ) : '-' }
                      </div>

                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Invoice Amount</div>
                        {item?.invoiceAmount ? (
                          <div className="font-muli font-bold text-secondary-900 break-normal">
                            {invoiceCurrency}
                            {' '}
                            {item?.airfareValue === 'Cancelled' ? '-' : null}
                            {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item?.invoiceAmount)}
                            {invoiceCurrency.trim() !== 'USD' && (
                            <>
                              {' (USD '}
                              {item?.airfareValue === 'Cancelled' ? '-' : null}
                              {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item?.usdInvoiceAmount) || '-'}
                              {')'}
                            </>
                            )}
                          </div>
                        ) : '-' }
                      </div>

                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Accounting Doc No</div>
                        <div className="font-muli font-bold">
                          {item.sapInvoiceNumber
                            ? item.sapInvoiceNumber
                            : item.shipnetVoucher
                            ? item.shipnetVoucher
                            : '-'}
                        </div>
                      </div>

                      <div className="flex flex-col gap-1">
                        <div className="font-muli">Invoice Number</div>
                        <div className="font-muli font-bold">
                           {item.invoiceNumber || '-'}
                        </div>
                      </div>
                    </div>
                  </div>
                  <ShortCloseApprovalSection
                    item={item}
                    isVendor={isVendor === 'true'}
                    loggedInUserEmail={loginUserEmail}
                    handleReject={handleReject}
                    handleApprove={handleApprove}
                    canEdit={policies?.vendorDashboardPolicies?.canEdit
                      || policies?.poPolicies?.canEdit}
                  />
                  {checkCategoryValues(item?.categoryDetails) || item?.ppeCategoryDetails ? (
                  <div className="flex flex-col justify-between border-t-2 border-primary-100 rounded-b-md">
                            <div
                            className="cursor-pointer flex justify-between bg-white text-sm p-2"
                            style={{ backgroundColor: item?.isShortClosed ? '#F1F1F1' : '#F0F3FB', color: '#333869' }}
                            onClick={() => {
                              if (show.indexOf(key) > -1) {
                                const temp = [...show];
                                temp.splice(temp.indexOf(key), 1);
                                setShow(temp);
                              } else {
                                const temp = [...show];
                                temp.push(key);
                                setShow(temp);
                                }
                            }}
                            >
                               {isCrewPageOnly && (
                             <span className="hover-link"> More Details </span>
                               )}
                              {!isCrewPageOnly && (
                             <span className="hover-link">PPE - More Details </span>
                               )}
                            </div>

                    <div
                   style={{ backgroundColor: item?.isShortClosed ? '#F1F1F1' : '#F0F3FB' }}
                    className=" text-gray-300rounded-md"
                    >
                      <div className="flex flex-col">
                      {show.indexOf(key) > -1 && (
                    <>
                    {item?.ppeCategoryDetails ? (
                      <>
                               {item?.ppeDeliveryRemarks && (
                          <p className="text-gray-500 font-regular text-md p-2 break-all">
                          PPE Delivery Remarks:
                          {' '}
                          <span className="font-normal">{item?.ppeDeliveryRemarks}</span>
                          </p>
                                    )}
                    { item?.ppeCategoryDetails?.filter((items) => !items?.isAdhoc).length > 0 && (
                      <div className="p-2">
                      <PPETable
                      columns={columns}
                      isAdhoc={false}
                      data={item?.ppeCategoryDetails}
                      currency={currency}
                      />
                      </div>
                    )}
                      { item?.ppeCategoryDetails?.filter((items) => items?.isAdhoc).length > 0 && (
                      <div>
                      {isCrewPageOnly && (
                      <p className="text-gray-500 font-regular text-md p-2 break-all">
                      PPE- Adhoc item
                          {' '}
                      </p>
                       )}
                      <div className="p-2">
                      <PPETable
                      columns={columns}
                      isAdhoc
                      data={item?.ppeCategoryDetails}
                      currency={currency}
                      />
                      </div>
                      </div>
                       )}
                      </>
                    ) : (
                    <div className="grid grid-cols-5 gap-4 p-4 justify-between rounded-md break-words">
                        {category?.expenseFields?.map((expense, index) => (
                          <div className="flex flex-col ">
                            <div className="font-muli">{category?.expenseFields[index]?.label}</div>
                            {category?.expenseFields[index]?.label.includes('Date') || category?.expenseFields[index]?.label.includes('Check') || category?.expenseFields[index]?.label.includes('Session') || category?.expenseFields[index]?.label.includes('To') ? (
                            <div className="font-muli font-bold flex">
                            <img src={datePicker} alt="datePicker" className=" w-6 pr-1" />
                            {item?.categoryDetails[index]?.value ? moment(item?.categoryDetails[index]?.value).format('DD-MM-YYYY') : '-'}
                            </div>
                            ) : (
                            <div className="font-muli font-bold">
                              {item?.categoryDetails[index]?.value || '-'}
                            </div>
                            )}
                          </div>
                        ))}
                        {expenseCategoryName.includes('Hotel') && (
                          <div className="flex flex-col">
                            <div className="font-muli">No. of Days</div>
                            <div className="font-muli font-bold flex">
                              {CalculateNoOfDays(
                                item?.categoryDetails[0]?.value,
                                item?.categoryDetails[1]?.value
                              ) || '-'}
                            </div>
                          </div>
                            )}
                    </div>
                    )}
                    </>
                    )}
                      </div>
                    </div>
                  </div>
                  ) : null}
                  {!isAgencyPage && item?.crewCode === null && (
                  <div className="col-span-3 flex flex-row mt-2 ">
                    <img className="action-icon w-6 mr-2" src={warningIcon} alt="warning" title="warning" />
                  <span className="font-muli text-sm text-red-500"> Unable to retrieve the crew details, kindly contact Admin </span>
                  </div>
                  )}
                </>
              ))}
            </>
          )}
          {!isAgencyPage && dateOfService?.length !== 0 && (
            <div
              onClick={() => {
                return setopenDate(!openDate);
              }}
              className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
            >
              <span className="text-base font-montserrat text-white-light capitalize font-bold">Date of service</span>
              <img src={polygon} alt="polygon" className={`${!openDate ? 'transform -rotate-90' : ''} w-6`} />
            </div>
          )}
          {!isAgencyPage && openDate && dateOfService?.length !== 0 && (
            <div className=" pb-2 mt-2 ">
              <div style={{ backgroundColor: '#F1F1F1' }} className="rounded-lg">
                {dateOfService?.map((date) => (
                  <div className="flex flex-row p-4">
                    <img src={datePicker} alt="datePicker" className=" w-6" />
                    <span className="pl-2 font-bold">
{' '}
{handleDate(date?.dateOfServices)}
{' '}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {isAgencyPage && (
        <PoAttachments
          name="attachments"
          values={{}}
          setFieldValue={() => {}}
          disabled
          showHeader
          headerTitle="PO - Attachments"
          showDeleteButton={false}
          showAddButton={false}
          poId={id ?? poId}
        />
      )}
      {isAgencyPage && (
        <AdvanceRequestDetailView
          advancePurchaseOrder={
            advancePurchaseOrderFromApi?.length
              ? advancePurchaseOrderFromApi
              : (data?.data?.advancePurchaseOrder ?? [])
          }
          paymentTermsOptions={paymentTermsOptions}
        />
      )}
       {isAgencyPage && (
        <ApprovalFlowLog
          poId={id ?? poId}
          disabled={poStatus?.toLowerCase() !== 'draft'}
        />
      )}
          {description && (
            <p className="text-gray-500 font-regular text-md p-2 break-all">
              Description:
{' '}
<span className="font-normal">{description}</span>
            </p>
          )}

        </div>
      </Card>
      {showLevel2ApproverSection && (
        <>
        <div className="mx-12 mb-4">
          <div
            onClick={() => setLevel2ApproverOpen((s) => !s)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setLevel2ApproverOpen((s) => !s)}
            aria-expanded={level2ApproverOpen}
            className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
          >
            <div className="text-base font-muli text-white-light font-bold">Level 2 Approver</div>
            <img src={polygon} alt="toggle" className={`${!level2ApproverOpen ? 'transform -rotate-90' : ''} w-6`} />
          </div>
          {level2ApproverOpen && (
            <div className="p-4 rounded border bg-white" style={{ border: '2px solid #EEEEEE', borderRadius: '10px' }}>
              <div className="flex w-fit max-w-full flex-row items-center gap-1">
                <div className="w-70 max-w-full">
                  <DropDown
                    options={level2ApproverOptions}
                    value={
                      level2ApproverOptions.find((o) => o.value === selectedLevel2ApproverId)
                      || level2ApproverOptions[0]
                    }
                    isSearchable
                    isClearable
                    isDisabled={!isLevel2DropdownEditable || isUpdateLevel2Loading}
                    onChange={(option) => setSelectedLevel2ApproverId(option?.value ?? '')}
                    filterOption={(option, rawInput) => {
                      const labelText = option?.label ?? '';
                      const input = (rawInput || '').toLowerCase();
                      return labelText.toString().toLowerCase().includes(input);
                    }}
                  />
                </div>
                {canUpdateLevel2Approver && (
                  <Tooltip title="Update Level 2 Approver" arrow placement="top">
                    <span className="inline-flex">
                      <button
                        type="button"
                        onClick={handleUpdateLevel2Approver}
                        disabled={isUpdateLevel2ButtonDisabled}
                        aria-label="Update Level 2 Approver"
                        className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md shadow-sm transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
                        style={{ backgroundColor: '#f8b113' }}
                      >
                        <img src={tickWhiteIcon} alt="" className="h-6 w-6 pointer-events-none" />
                      </button>
                    </span>
                  </Tooltip>
                )}
              </div>
            </div>
          )}
        </div>
        {showAgencyApprovalButtons && (
        <div className="mx-12 mb-6 flex flex-row justify-end gap-4 items-center">
          <Button
            type="button"
            onClick={handleCancel}
            rounded
            size="medium"
            variant="outlined"
            style={{ borderColor: 'rgba(248, 177, 19, 1)', color: '#6b7280' }}
          >
            CANCEL
          </Button>
          {isEnableAgencyPoApproval === true && (
            <>
              <Button
                type="button"
                onClick={() => openAgencyApprovalModal('SendBack')}
                rounded
                size="medium"
                variant="outlined"
                disabled={isApprovalLoading}
                style={{ borderColor: 'rgba(248, 177, 19, 1)', color: '#6b7280' }}
              >
                SEND BACK
              </Button>
              <Button
                type="button"
                onClick={() => openAgencyApprovalModal('Approve')}
                rounded
                size="medium"
                variant="filled"
                disabled={isApprovalLoading}
                style={{ backgroundColor: 'rgba(248, 177, 19, 1)', color: '#fff' }}
              >
                APPROVE
              </Button>
            </>
          )}
          {isEnableAgencyPoReject === true && (
            <Button
              type="button"
              onClick={() => openAgencyApprovalModal('Reject')}
              rounded
              size="medium"
              variant="outlined"
              disabled={isApprovalLoading}
              style={{ borderColor: 'rgba(248, 177, 19, 1)', color: '#6b7280' }}
            >
              REJECT
            </Button>
          )}
        </div>
        )}
        </>
      )}
      <Comment isVendor={isVendor === 'true'} />
      {showApprovePopup && (
        <ConfirmApprovel
          showApprovePopup={showApprovePopup}
          setShowApprovePopup={setShowApprovePopup}
          data={{ poNumber, selectedLineItem, currency, isVendor }}
          type="Approve"
        />
      )}
      {showRejectPopup && (
        <ConfirmApprovel
          showApprovePopup={showRejectPopup}
          setShowApprovePopup={setShowRejectPopup}
          data={{ poNumber, selectedLineItem, currency, isVendor }}
          type="Reject"
        />
      )}
      {isLoading && (
        <Loader />
      )}
      {agencyApprovalModal.open && (
        <Modal
          open={agencyApprovalModal.open}
          onClose={closeAgencyApprovalModal}
          center
          showCloseIcon
          styles={{ modal: { padding: '24px', borderRadius: '8px', maxWidth: '420px' } }}
        >
          <div className="py-4 px-2 font-muli">
            <h2 className="text-lg font-bold mb-4">
              {agencyApprovalModal.action === 'Approve' && 'Approve'}
              {agencyApprovalModal.action === 'Reject' && 'Reject'}
              {agencyApprovalModal.action === 'SendBack' && 'Send Back'}
              {' PO'}
            </h2>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-100 mb-2">Approver Comments</label>
              <textarea
                className="w-full border border-gray-300 text-gray-100 rounded p-2 text-sm min-h-[80px]"
                placeholder="Enter comments (optional)"
                value={agencyApprovalComment}
                onChange={(e) => setAgencyApprovalComment(e.target.value)}
                rows={3}
              />
            </div>
            <div className="flex justify-end gap-2">
              <Button type="button" variant="outlined" rounded size="medium" onClick={closeAgencyApprovalModal}>
                Cancel
              </Button>
              <Button
                type="button"
                variant="filled"
                rounded
                size="medium"
                disabled={isApprovalLoading}
                style={{ backgroundColor: 'rgba(248, 177, 19, 1)', color: '#fff' }}
                onClick={submitAgencyApproval}
              >
                {isApprovalLoading ? 'Submitting...' : 'Confirm'}
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {modal && approvalConfig?.shortCloseApprovalRequired ? (
        <RequestShortClose
          modal={modal}
          isLoading={isSCLoading}
          setModal={setModal}
          handleDelete={handleShortClose}
          approvalConfig={approvalConfig}
          vendorId={vendorId}
          purchaseOrderId={id}
          lineItemId={modalData}
        />
      ) : modal && (
        <ConfirmShortClose
          modal={modal}
          setModal={setModal}
          handleDelete={handleDelete}
          shortCloseReason={shortCloseReason}
          setShortCloseReason={setShortCloseReason}
          message=" Short Close"
        />
      )}
      {isActive
      && (
    <Footer
    dataFail={finalFetch?.isSyncFailure}
    handleCancel={handleCancel}
    showAdd={false}
    isCrewPage={isCrewPage}
    handleEdit={handleEdit}
    isAgencyPage={isAgencyPage}
    isAgencyPoEditable={isAgencyPoEditable}
    />
)}
    </div>
  );
};

export default PODetailPage;
